<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="container">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-6 col-sm-4 pb-0 mb-0">
        <img *ngIf="especie === 'CP'" src="assets/img/conta-publica.png" alt="pesquisa" title="" height="32" width="32">
        <img *ngIf="especie === 'PLAN'" src="assets/img/planejamento.png" alt="pesquisa" title="" height="32"
          width="32">
        <span *ngIf="especie === 'CP'" class="titulo-txt-l pl-2">ANEXOS - CONTAS PÚBLICAS</span>
        <span *ngIf="especie === 'PLAN'" class="titulo-txt-l pl-2">ANEXOS - PLANEJAMENTO</span>
      </div>
      <div class="col-md-6 col-sm-8 pb-0 mb-0">
        <a [routerLink]="['/transparencia']" class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="30" width="30">
        </a>
        <button [routerLink]="['/admin/transparencia/parametros-transparencia']"
          class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/global/back.png" alt="pesquisa" title="Voltar aos parâmetros" height="30" width="30">
        </button>
        <button *ngIf="tipo" (click)="inserirArquivo()" type="button"
          class="btn btn-success btn-sm float-right mr-3">Inserir
          arquivo</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 pt-0 mt-0">
        <label style="font-weight: bold; color: #757575">
          {{login.orgao.codigo}} {{login.orgao.nome}}
        </label>
      </div>
    </div>
    <hr class="mt-1 mb-4" />
    <div class="row">
      <div class="form-group col-sm-4 col-md-3 col-lg-2 col-xl-2">
        <select [(ngModel)]="selectExercicio" (change)="preencherGrid()" name="selectExercicio"
          style="border: none !important" style="font-weight: bold;" class="custom-select">
          <option [selected]="item.ano === selectExercicio" [value]="item.ano" *ngFor="let item of listaExercicios">
            {{item.ano}}
          </option>
        </select>
      </div>
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5">
        <div class="form-group">
          <select [(ngModel)]="tipo" (change)="preencherGrid()" name="selectSituacao" style="border: none !important"
            style="font-weight: bold;" class="custom-select">
            <option [ngValue]="undefined">Todas</option>
            <option [value]="item.id" *ngFor="let item of listaTipos">
              {{item.nome}}
            </option>
          </select>
        </div>
      </div>
      <div class="col-sm-4 col-md-4 col-lg-5 col-xl-5 mr-0 pr-0">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row" *ngIf="lista.length > 0">
      <div class="col-md">
        <table class="table table-eddy" style="font-size: 13px;">
          <thead>
            <tr style="height: 42px;">
              <th scope="col" class="text-center">
                <a href="javascript:;" (click)="ordenar(1)" class="text-black-50">
                  <span *ngIf="col === 1"><img src="assets/img/global/{{imagem}}" alt="1" height="16"
                      width="16">&nbsp;</span>DATA ANEXO
                </a>
              </th>
              <th scope="col" class="text-center">
                <a href="javascript:;" (click)="ordenar(2)" class="text-black-50">
                  <span *ngIf="col === 2"><img src="assets/img/global/{{imagem}}" alt="2" height="16"
                      width="16">&nbsp;</span>ANO
                </a>
              </th>
              <th scope="col" class="text-center" *ngIf="especie === 'CP'">
                <span class="text-black-50">REFERÊNCIA</span>
              </th>
              <th scope="col">
                <a href="javascript:;" (click)="ordenar(4)" class="text-black-50">
                  <span *ngIf="col === 4"><img src="assets/img/global/{{imagem}}" alt="4" height="16"
                      width="16">&nbsp;</span>NOME
                </a>
              </th>
              <th scope="col">
                <a href="javascript:;" (click)="ordenar(5)" class="text-black-50">
                  <span *ngIf="col === 5"><img src="assets/img/global/{{imagem}}" alt="3" height="16"
                      width="16">&nbsp;</span>ÓRGÃO
                </a>
              </th>
              <th scope="col" class="text-right">
                <a href="javascript:;" (click)="ordenar(6)" class="text-black-50">
                  <span *ngIf="col === 6"><img src="assets/img/global/{{imagem}}" alt="7" height="16"
                      width="16">&nbsp;</span>TAMANHO
                </a>
              </th>
              <th scope="col" style="width: 50px;"> </th>
              <th scope="col" style="width: 50px;"> </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of lista">
              <td class="text-center">{{item.data_anexo | date:'dd/MM/yyyy':'GMT'}}</td>
              <td class="text-center">{{item.ano}}</td>
              <td class="text-center" *ngIf="especie === 'CP'">{{retornarReferencia(item)}}</td>
              <td>{{item.nome}}</td>
              <td>{{item.orgao.nome}}</td>
              <td class="text-right">{{item.tamanho}}</td>
              <td class="text-center">
                <a href="javascript:void" (click)="download(item)">
                  <img src="assets/img/global/download_cloud.png" alt="cvs" title="download" height="22" width="22">
                </a>
              </td>
              <td class="text-center">
                <button (click)="remover(item)" title="Remover arquivo" class="btn btn-sm btn-outline-primary mr-2">
                  <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row float-right" *ngIf="lista && lista.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
    <div class="row" *ngIf="lista.length === 0">
      <div class="col-12 mt-5 ml-3">
        <img src="assets/img/global/warning.png" alt="atencao" class="mb-1">
        <br />
        <span style="color: #6a6a6a; font-weight: bold;">NÃO HÁ LANÇAMENTOS EFETUADOS NESTE PERÍODO! </span>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="dialogUpload" tabindex="-1" role="dialog" aria-labelledby="uploadArquivo"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="exampleModalLongTitle">Enviar arquivo e salvar</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-3">
            <label for="data_anexo">Data anexo<span class="text-danger">*</span></label>
            <p-calendar id="data_anexo" [(ngModel)]="entidade.data_anexo" inputStyleClass="form-control" dataType="date"
              dateFormat="dd/mm/yy" [locale]="ptBR" dateFormat="dd/mm/yy" [showIcon]="true" [showOnFocus]="false"
              [showButtonBar]="true" [style]="{ width: '100%' }">
            </p-calendar>
          </div>
          <div class="col-md-3">
            <label for="data_anexo">Ano<span class="text-danger">*</span></label>
            <input class="form-control font-weight-bold" type="text" [(ngModel)]="entidade.ano" />
          </div>
          <div class="col-md-5">
            <label for="data_anexo">Referência<span class="text-danger">*</span></label>
            <input class="form-control font-weight-bold" type="text" [(ngModel)]="entidade.referencia" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label for="descricao">Descrição<span class="text-danger">*</span></label>
            <input class="form-control font-weight-bold" type="text" [(ngModel)]="entidade.descricao" />
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-12">
            <form enctype="multipart/form-data">
              <p-fileUpload #fileUpload customUpload=true (uploadHandler)="onUpload($event, fileUpload)" chooseLabel="Selecionar"
                uploadLabel="Enviar" cancelLabel="Cancelar" multiple="multiple"
                accept=".pdf,.csv,.xml,.png,.xls,.xlsx,.odt" maxFileSize="1000000000">
                <ng-template pTemplate="content">
                  <ul *ngIf="uploadedFiles.length">
                    <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
                  </ul>
                </ng-template>
              </p-fileUpload>
            </form>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button #btnCancelarUpload type="button" class="btn btn-secondary" id="btnCancelarUpload"
          data-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>